import { render, staticRenderFns } from "./RecordingServer.vue?vue&type=template&id=8e78bba4&scoped=true"
import script from "./RecordingServer.vue?vue&type=script&lang=js"
export * from "./RecordingServer.vue?vue&type=script&lang=js"
import style0 from "./RecordingServer.vue?vue&type=style&index=0&id=8e78bba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e78bba4",
  null
  
)

export default component.exports